import type { AdminResourceType } from 'types';

export interface FormErrors {
  location?: string;
  category?: string;
  name?: string;
  url?: string;
  file?: string;
  roles?: string;
}

export function validateResourceForm(
  locationId: number | null,
  categoryId: number | null,
  name: string,
  resourceType: AdminResourceType,
  url: string,
  file: File | null,
  audience: 'Everyone' | 'Specific Roles',
  selectedRoleIds: Set<number>,
  isExistingFile = false,
): FormErrors {
  const errors: FormErrors = {};
  if (locationId === null) errors.location = 'Location is required.';
  if (categoryId === null) errors.category = 'Folder is required.';
  if (!name.trim()) errors.name = 'Name is required.';
  if (resourceType === 'URL') {
    if (!url.trim()) {
      errors.url = 'URL is required.';
    } else {
      try {
        const parsed = new URL(url.trim());
        if (!/^https?:$/.test(parsed.protocol)) {
          errors.url = 'URL must use http:// or https://';
        }
      } catch {
        errors.url = 'Please enter a valid URL (e.g. https://example.com).';
      }
    }
  }
  if (resourceType === 'File' && !file && !isExistingFile) errors.file = 'Please select a file.';
  // No error for empty role selection — zero roles = treated as Everyone by the API.
  return errors;
}
